import { render, staticRenderFns } from "./UnionItemEdit.vue?vue&type=template&id=6600f466&scoped=true&"
import script from "./UnionItemEdit.vue?vue&type=script&lang=js&"
export * from "./UnionItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnionItemEdit.vue?vue&type=style&index=0&id=6600f466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600f466",
  null
  
)

export default component.exports